<div class="pending-info" *ngIf="!accessRequestSent; else sent">
  <mat-icon class="pending-icon">hourglass_empty</mat-icon>
  <h3>{{ 'sso.pendingAccess.title' | loc }}</h3>
  <p class="mat-body-1">{{ 'sso.pendingAccess.message' | loc }}</p>
  <p class="mat-caption pending-email">{{ email }}</p>
  <p class="mat-body-1">{{ 'sso.pendingAccess.giveData' | loc }}</p>
  <app-text-input [formControl]="ssoDisplayNameCtrl" [footer]="false"></app-text-input>
  <p class="mat-caption">{{ 'sso.pendingAccess.contactAdmin' | loc }}</p>
</div>
<ng-template #sent>
  <div class="pending-info">
    <mat-icon class="pending-icon" style="color: green">check_circle</mat-icon>
    <h3>{{ 'sso.requestSent.title' | loc }}</h3>
    <p class="mat-body-1">{{ 'sso.requestSent.message' | loc }}</p>
    <p class="mat-caption pending-email">{{ email }}</p>
    <p class="mat-caption">{{ 'sso.requestSent.nextSteps' | loc }}</p>
  </div>
</ng-template>
<div class="flex-column margin-top-10">
  <button
    class="margin-bottom-10"
    mat-flat-button
    color="primary"
    (click)="requestAccess()"
    [disabled]="isRequestingAccess || accessRequestSent"
  >
    {{ 'sso.requestAccess.' + getButtonSuffix() | loc }}
  </button>
  <button mat-stroked-button color="primary" (click)="backToEmail()">{{ 'sso.pendingAccess.backToLogin' | loc }}</button>
</div>
